import axios from 'axios';
const BASE_URL = process.env.REACT_APP_API_BASE_URL;
console.log("BASE_URL", BASE_URL);

export const apiClient = axios.create({
  baseURL: BASE_URL,
});

// Example generic get method
export const getRequest = (endpoint: string, params = {}, auth: boolean = false) => {
  const headers: any = {};
  if (auth) {
    const token = localStorage.getItem("token");
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
  }
  return apiClient.get(endpoint, { params, headers });
};

// You can also add post, put, delete helpers similarly if you want
export const postRequest = (endpoint: string, data = {}) => {
  return apiClient.post(endpoint, data);
};

// Fetch single blog by slug or id
export const fetchBlogBySlug = (slug: string) => {
  return apiClient.get(`/blogs/${slug}`);
};

// Fetch single Mcqs by slug
export const fetchMcqsBySlug = (slug: string) => {
  return apiClient.get(`/mcqs/${slug}`);
};

// Fetch test series list by slug
export const fetchAllTestSeriesBySlug = (slug: string) => {
  return apiClient.get(`/online-tests/${slug}`);
};

// Fetch User test series status
export const fetchUsersTestStatus = (userId: string, slug: string) => {
  return apiClient.get(`/online-test/user-tests-status/${userId}/${slug}`);
};

// Fetch User test Access series status
export const fetchUsersTestAccessStatus = (userId: string, testBlogSlug: string) => {
  return apiClient.get(`/online-test/user-test-access-status/${userId}/${testBlogSlug}`);
};

// Fetch test series details
export const fetchTestDetailsQuestions = (slug: string | undefined, testId: string | undefined ) => {
  return apiClient.get(`/online-test/test-questions/${slug}/${testId}`);
};

// Fetch test series On going details
export const fetchTestDetailsOngoing = (userId: string, testId: string | undefined, ) => {
  return apiClient.get(`/online-test/ongoing/${userId}/${testId}`);
};

// Fetch test series On going details
export const fetchTestResultSummary = (userId: string, testId: string | undefined, ) => {
  return apiClient.get(`/online-test/result-summary/${userId}/${testId}`);
};

// Fetch test solutions and analysis
export const fetchTestSolutions = (userId: string, testId: string | undefined, ) => {
  return apiClient.get(`/online-test/test-solutions/${userId}/${testId}`);
};